import React, { type ReactElement } from 'react'

interface ImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string
  alt?: string
  size?: string
  width?: string
  height?: string
  styles?: string
  sx?: React.CSSProperties
}

const Image = ({
  src,
  alt,
  size,
  width,
  height,
  styles,
  sx,
  ...props
}: ImageProps): ReactElement => {
  return (
    <img
      src={src}
      alt={alt}
      style={{
        width: size || width || '30px',
        height: size || height || '30px',
        ...sx,
      }}
      {...props}
      className={styles}
    />
  )
}

export default Image
